import {
	setAlert,setAlertNextPage
} from 'helpers/alertHelpers';
import { addPaymentInfo } from 'helpers/dataLayerHelpers';
import {
	braintreeSave,postCheckout
} from 'helpers/paymentHelpers';
import isEmpty from 'lodash/isEmpty';
import React, {
	Component, Fragment
} from 'react';

import PaypalUISelector from '../ui/Paypal';

class PaypalCheckout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			paypalMounted: false,
		}
		this.setup = this.setup.bind(this)
		this.open = this.open.bind(this)
		this.handleTokenError = this.handleTokenError.bind(this)
		this.handleTokenization = this.handleTokenization.bind(this)
	}

	componentDidMount() {
		this.setup()
	}

	componentWillUnmount() {
		this.paypalTokenizeReturn && this.paypalTokenizeReturn.close()
	}

	setup() {
		if (isEmpty(this.props.braintreeToken)) { return }
		if (!window.braintree || !window.braintree.client || !window.braintree.paypal) { return }
		window.braintree.client.create({
			authorization: this.props.braintreeToken,
		},
		(clientErr, clientInstance) => {
			if (clientErr) {
				console.error('Error creating client: ',
					clientErr)
				// turn off loading state.
			}
			window.braintree.paypal.create({
				client: clientInstance,
			},
			(paypalErr, paypalInstance) => {
				if (paypalErr) {
					console.error('Error creating Paypal: ',
						paypalErr)
					return
				}
				if (paypalInstance) {
					this.paypal = paypalInstance
					this.setState({ paypalMounted: true })
					if (this.props.report) {
						this.props.report(this.props.reportProperty,
							true)
					}
				}
			})
		})
	}

	setError(error) {
		this.setState({ error })
	}

	open() {
		const { setBodyBusy } = this.props;
		setBodyBusy(true)
		this.setError('')
		if (!this.paypal) {
			this.handleUnsupportedBrowser()
			setBodyBusy(false)
			return
		}
		const costCents = this.props.cart.cartTotal * 100

		this.paypalTokenizeReturn = this.paypal.tokenize(
			{
				flow: 'vault',
				amount: costCents,
				currency: 'USD',
				displayName: 'Apostrophe',
				locale: 'en_US',
				enableShippingAddress: false,
				billingAgreementDescription: this.props.chargeDescription,
			},
			this.handleTokenization
		)
	}

	async handleTokenization(tokenizeErr, payload) {
		const {
			setBodyBusy, openCrossSell,
		} = this.props;
		if (tokenizeErr) {
			return this.handleTokenError(tokenizeErr)
		}
		try {
			setBodyBusy(true)
			const res = await braintreeSave({ payload },
				this.props.CSRFToken)
			let errMsg = 'An unexpected error occurred while trying to save your payment details. Please contact care@apostrophe.com for assistance.'
			if (!isEmpty(res.success)) {
				if (res.response && res.response.existing_payments) {
					if (!this.props.saveOnly) {
						const checkout = await postCheckout(this.props,
							'paypal')
						if (checkout.success) {
							setAlertNextPage('success',
								checkout.successMessage)
							const {
								response, nextStep,
							} = checkout;
							console.log(response)
							if (response.cross_sell) {
								setBodyBusy(false)
								openCrossSell(nextStep,
									response.cross_sell);
							} else {
								window.location = nextStep
							}
						} else {
							setAlert('error',
								checkout.errorMessage)
							setBodyBusy(false)
						}
					} else {
						setAlert('success',
							'Successfully updated paypal information.')
						this.props.propogatePaymentInfo(res.response.existing_payments)
						setBodyBusy(false)
					}
				} else {
					console.log(res)
					this.setError(errMsg)
					setBodyBusy(false)
				}
			} else {
				if (!isEmpty(res.error)) {
					errMsg = res.error
				}
				this.setError(errMsg);
				setBodyBusy(false);
			}
		} catch (err) {
			console.log(err)
			setBodyBusy(false)
		}
	}

	handleTokenError(error) {
		const { setBodyBusy } = this.props;
		switch (error.code) {
		case 'PAYPAL_POPUP_CLOSED':
			console.log('Customer closed PayPal popup.')
			break
		case 'PAYPAL_ACCOUNT_TOKENIZATION_FAILED':
			console.error('PayPal tokenization failed. See details:',
				error.details);
			this.setError('There was an error communicating with PayPal. Please try again, or contact care@apostrophe.com for assistance.')
			break;
		case 'PAYPAL_FLOW_FAILED':
			console.log('Unable to initialize PayPal flow. Are your options correct?',
				error.details);
			this.handleUnsupportedBrowser()
			break;
		case 'PAYPAL_TOKENIZATION_REQUEST_ACTIVE':
			this.setError('Ensure that your browser allows pop-ups, and a PayPal form has not already been opened in a new window');
			setBodyBusy(false)
			return; // don't fall through to remove selected state
		default:
			this.setError('There was an error submitting your payment information. Please try again, or contact care@apostrophe.com for assistance.');
		}
		setBodyBusy(false)
	}

	handleUnsupportedBrowser() {
		const error = 'Paypal checkout is not available on this browser. Try another payment method.'
		this.setError(error)
		this.props.setBodyBusy(false)
	}

	render() {
		return (

			<div onClick={() => addPaymentInfo('Paypal')}>
				<PaypalUISelector
					medCheckout={this.props.medCheckout}
					open={this.open}
					{...this.props}
				/>
				<div>
					{this.state.error}
				</div>
			</div>
		)
	}
}

PaypalCheckout.defaultProps = {
	payNow: true,
}
export default PaypalCheckout;
